import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function OfferSection() {
  const items = ['Protocolo completo em ebook', 'Cardápio de 21 dias', 'Checklist diário', 'Protocolo SOS 24h', 'Ritual matinal de 2 minutos', 'Lista de substituições inteligentes', 'Acesso imediato por e-mail'];
  return <section id="oferta" className="py-16 md:py-24 bg-brand-beige" data-id="element-191">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-192">
        <div className="bg-white rounded-3xl shadow-xl border border-brand-sage/30 overflow-hidden" data-id="element-193">
          <div className="bg-brand-dark text-white text-center py-6 px-8" data-id="element-194">
            <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" data-id="element-195">
              Oferta Especial
            </h2>
            <p className="text-white/80" data-id="element-196">
              Hoje você recebe acesso completo ao Protocolo Desincha40+ por
              apenas:
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-197">
            <div className="text-center mb-8" data-id="element-198">
              <div className="inline-block bg-brand-pink/50 text-brand-dark text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-199">
                Promoção por tempo limitado
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-200">
                <span className="text-brand-text/50 text-xl line-through mb-1" data-id="element-201">
                  De R$ 345,00
                </span>
                <span className="text-5xl md:text-6xl font-bold text-brand-dark mb-2" data-id="element-202">
                  R$ 50,00
                </span>
                <span className="text-brand-text/70 text-sm" data-id="element-203">
                  Ou em até 7x no cartão.
                </span>
              </div>
            </div>

            <div className="bg-brand-cream rounded-2xl p-6 mb-8 border border-brand-sage/20" data-id="element-204">
              <ul className="space-y-3" data-id="element-205">
                {items.map((item, index) => <li key={index} className="flex items-center text-brand-text" data-id="element-206">
                    <CheckIcon className="w-5 h-5 text-brand-sage-dark mr-3 flex-shrink-0" data-id="element-207" />
                    <span className="font-medium" data-id="element-208">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center" data-id="element-209">
              <a href="https://pay.hotmart.com/B106409754W" onClick={trackAddToCart} className="block w-full bg-green-600 hover:bg-green-700 text-white text-center font-bold px-6 py-5 rounded-xl text-lg md:text-xl transition-all duration-300 shadow-lg transform hover:-translate-y-1 mb-4" data-id="element-210">
                QUERO COMEÇAR O DESINCHA40+ AGORA
              </a>
              <div className="flex items-center justify-center text-sm text-brand-text/60" data-id="element-211">
                <LockIcon className="w-4 h-4 mr-2" data-id="element-212" />
                Compra segura via Hotmart.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}